export const required =
  (err: string) =>
  (value = ''): string => {
    const match = value.match(/\S/);
    if (!match) {
      return err;
    }
    return '';
  };
